import { render, staticRenderFns } from "./questionList.vue?vue&type=template&id=61a30626&"
import script from "./questionList.vue?vue&type=script&lang=js&"
export * from "./questionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports